import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface GarageOverheadDoorProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const GarageOverheadDoor: React.FC<GarageOverheadDoorProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [garageOverheadDoor, setGarageOverheadDoor] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Exterior Features']?.['Garage/Overhead Door'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Exterior Features': { ...s.values?.['Exterior Features'], 'Garage/Overhead Door': v } } })
    );
    const label = 'Garage/Overhead Door';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={garageOverheadDoor}
                />
            ) : (
                <TextBox
                    value={garageOverheadDoor ?? ''}
                    onChange={(value) => setGarageOverheadDoor(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
